import React from 'react';
import { connect } from 'react-redux';
import { DesktopContainer } from 'components/video-collection/desktop/container';
import { isEqual } from 'lodash-es';
import * as PropTypes from 'prop-types';

class DesktopCollection extends React.Component {
  componentDidMount() {
    this.props.dispatch(this.props.loadCollectionAction);
  }

  componentDidUpdate(prevProps) {
    if (!isEqual(this.props.loadCollectionAction.payload, prevProps.loadCollectionAction.payload)) {
      this.props.dispatch(this.props.loadCollectionAction);
    }
  }

  render() {
    return (
      <DesktopContainer baseUrl={this.props.baseUrl} withSort={this.props.withSort} sortBy={this.props.sortBy}>
        {this.props.children}
      </DesktopContainer>
    );
  }
}

export const DesktopCollectionDecorated = connect(null, (dispatch) => ({ dispatch }))(DesktopCollection);

DesktopCollection.propTypes = {
  baseUrl: PropTypes.string.isRequired,
  withSort: PropTypes.bool,
  sortBy: PropTypes.array,
  loadCollectionAction: PropTypes.object.isRequired,
  children: PropTypes.object,
};
